export class AuthorizationRoleInheritanceModel{
    id: string = null;
    authorizationRoleId: string;
    authorizationGroupRoleId: string;
    operationCreate : boolean;
    operationRead: boolean;
    operationUpdate : boolean;
    operationDelete : boolean;
    operationExecute: boolean;
}